import { useState } from "react";
import { Button, TextField, MenuItem, Card, DialogActions } from "@mui/material";
import MessageError from "../../messages/messageError";
import api from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import MessageSuccess from "../../messages/messageSuccess";
import LoadingShort from "../../load/loadingShort";
import { useNavigate } from "react-router-dom";
import FazerObservacoes from "../components/fazerObservacoes.";

export default function EncaminhaExpediente({ expediente, setUpdate }) {
  const [messageSuccess, setMessageSuccess] = useState("");
  const [messageError, setErrorMessage] = useState("");
  const [status, setStatus] = useState(expediente?.status);
  const [load, setLoad] = useState(false);
  const user = useSelector((state) => state.account.user);
  const [observacao, setObservacao] = useState('');
  const navigate = useNavigate()
  const dispatch = useDispatch()


  async function changeStatusExpediente() {
    setLoad(true);
    setErrorMessage("");
    setMessageSuccess("");

    await api
      .patch("/expediente/change-status", {
        status,
        expedienteId: expediente._id,
        userId: user._id,
        observacao
      })
      .then((response) => {
        // console.log(response)
        setLoad(false);
        setMessageSuccess(response.data.msg);
        setUpdate(response.data);

        dispatch({
          type: 'alert',
          payload: { alert: `O expediente foi encminhado para ${status}` },
        });

        window.setTimeout(() => {
          navigate('/admin/expediente/entradas')
        }, 5000);
      })
      .catch((error) => {
        // console.log(error)
        // setErrorMessage(error.response.data.message);
        setLoad(false);
      });
  }

  // console.log(obs)

  const expedienteArias = [
    // { area: 'Secretaria Director Geral', destinatario: 'Secretaria Director Geral' },
    // { area: 'Secretaria Director Adj. Área Admin', destinatario: 'Secretaria Director Adj. Área Admin' },
    { area: 'Chefe de Departamento', destinatario: 'Chefe de Departamento' },
    { area: 'Director Adj. Área Admin', destinatario: 'Director Adj. Área Admin' },
    { area: 'Director Adj. Área Técnica', destinatario: 'Director Adj. Área Técnica' },
    { area: 'Director Geral', destinatario: 'Director Geral' },
    { area: 'Indeferidir expediente', destinatario: 'Indeferido' },
    { area: 'Voltar para recepção', destinatario: 'Análise' },
    // { area: 'Finalizado', destinatario: 'Finalizado' },
  ]

  return (
    <Card style={{ padding: 10, border: '2px #85287e outset' }}>
      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}

      <TextField
        type="text"
        label="Encaminhar Para:"
        select
        fullWidth
        size="small"
        name="status"
        // variant="outlined"
        onChange={(e) => setStatus(e.target.value)}
        defaultValue={'??'}
      >
        <MenuItem disabled value={'??'} >??</MenuItem>
        {expedienteArias.map((expedienteAria, index) => (
          <MenuItem key={1000 + index} value={expedienteAria.destinatario} name="status">
            {expedienteAria.area}
          </MenuItem>
        ))}
      </TextField>

      {status !== expediente?.status && (
        <>
          {(status === 'Indeferido' || status === 'Análise') &&
            <FazerObservacoes
              setObs={setObservacao}
              obs={observacao}
              titulo="(Descreve aqui os motivos)"
            />
          }

          <DialogActions>

            <Button onClick={() => setStatus(expediente?.status)} color="error" size="small">Cancelar</Button>
            <Button
              disabled={load || !status}
              size="small"
              // variant="contained"
              onClick={changeStatusExpediente}
            >
              {load ? <LoadingShort /> : "Confirmar"}
            </Button>
          </DialogActions>
        </>
      )}
    </Card>
  );
}
